export abstract class Time {
  static seconds(milliseconds: number) {
    return milliseconds * 1000;
  }
  static minutes(milliseconds: number) {
    return Time.seconds(milliseconds * 60);
  }
  static hours(milliseconds: number) {
    return Time.minutes(milliseconds * 60);
  }
  static days(milliseconds: number) {
    return Time.hours(milliseconds * 24);
  }
  static weeks(milliseconds: number) {
    return Time.days(milliseconds * 7);
  }
  static months(milliseconds: number) {
    return Time.days(milliseconds * 30);
  }
  static years(milliseconds: number) {
    return Time.days(milliseconds * 365);
  }
}
